import { Suspense } from "react";
import SchedulePage from "@/app/booking/schedule/schedule-page";
import SchedulePageSkeleton from "@/components/schedule-page-skeleton";

export default function ReschedulePage() {
  return (
    <Suspense fallback={<SchedulePageSkeleton />}>
      <SchedulePage mode="reschedule" />
    </Suspense>
  )
}
